/**
 * Array Utils
 * 数组工具类：提供通用的数组操作方法
 */
(function() {
  'use strict';

  /**
   * ArrayUtils 工具类
   */
  class ArrayUtils {
    /**
     * 根据优先ID列表对数组进行排序
     * 将配置的优先ID对应的项提到数组最前面，其他项保持原有顺序
     * 
     * @param {Array} items - 原始数组
     * @param {string} priorityIdsStr - 优先ID字符串，格式如 "36533,12345,67890"，用逗号分隔
     * @param {string|function} idKey - 用于获取ID的键名或函数，默认为 'id'
     * @returns {Array} 排序后的数组
     * 
     * @example
     * // 使用默认 'id' 字段
     * const sorted = ArrayUtils.sortByPriorityIds(items, "36533,12345");
     * 
     * // 使用自定义字段
     * const sorted = ArrayUtils.sortByPriorityIds(items, "36533,12345", "customId");
     * 
     * // 使用函数获取ID
     * const sorted = ArrayUtils.sortByPriorityIds(items, "36533,12345", item => item.data.id);
     */
    static sortByPriorityIds(items, priorityIdsStr, idKey = 'id') {
      // 如果配置为空，返回原数组（保持接口默认排序）
      if (!priorityIdsStr || typeof priorityIdsStr !== 'string' || priorityIdsStr.trim() === '') {
        return items;
      }

      // 解析优先ID列表
      const priorityIds = priorityIdsStr
        .split(',')
        .map(id => id.trim())
        .filter(id => id !== '')
        .map(id => {
          // 尝试转换为数字，如果失败则保持字符串
          const numId = Number(id);
          return isNaN(numId) ? id : numId;
        });

      // 如果没有有效的优先ID，返回原数组
      if (priorityIds.length === 0) {
        return items;
      }

      // 获取ID的函数
      const getId = typeof idKey === 'function' 
        ? idKey 
        : (item) => item[idKey];

      // 分离优先项和普通项
      const priorityItems = [];
      const normalItems = [];

      items.forEach(item => {
        const itemId = getId(item);
        const isPriority = priorityIds.some(id => {
          // 同时支持数字和字符串比较
          return id === itemId || String(id) === String(itemId) || Number(id) === Number(itemId);
        });
        
        if (isPriority) {
          priorityItems.push(item);
        } else {
          normalItems.push(item);
        }
      });

      // 按照配置的顺序排列优先项
      const sortedPriorityItems = priorityItems.sort((a, b) => {
        const idA = getId(a);
        const idB = getId(b);
        const indexA = priorityIds.findIndex(id => 
          id === idA || String(id) === String(idA) || Number(id) === Number(idA)
        );
        const indexB = priorityIds.findIndex(id => 
          id === idB || String(id) === String(idB) || Number(id) === Number(idB)
        );
        return indexA - indexB;
      });

      // 合并：优先项在前，普通项在后
      return [...sortedPriorityItems, ...normalItems];
    }
  }

  // 导出到全局
  window.ArrayUtils = ArrayUtils;
})();
